var render = function render(){var _vm=this,_c=_vm._self._c;return _c('conferencia-list-geral',{attrs:{"items":_vm.concluidas}})
}
var staticRenderFns = []

export { render, staticRenderFns }